import {
    GET_USER,
    GET_PASSWORD_USER,
    GET_TERMS_CONDITIONS,
    GET_STATE_LOADING_PASSWORD_VALIDATION,
} from "@/views/login/store/types/types.js";

const getters = {
    [GET_USER]: state => state.user,
    [GET_PASSWORD_USER]: state => state.userPassword,
    [GET_TERMS_CONDITIONS]: state => state.terms_conditions,
    [GET_STATE_LOADING_PASSWORD_VALIDATION]: state => state.loading,
};

export default getters;